<template>
  <div id="registration-questions">
    <template>
      <!-- Single line text (Default: 10, Name: 1000, LastName: 10001, Title: 4, Instituon: 33, School: 5, State: 28, City:9, Postal Code: 29, Address line: 30, HES Code: 31), Department:34 -->
      <div class="registration-question" v-if="question.type == 10 || question.type == 1000 || question.type == 10001 || question.type == 4 || question.type == 3 || question.type == 33 || question.type == 5 || question.type == 28 || question.type == 9 || question.type == 29 || question.type == 30 || question.type == 31 || question.type == 34">
        <div class="sub-title">{{ question.title }} <span v-show="question.isRequired">*</span></div>
        <el-input v-model="question.answer" :required="question.isRequired" :placeholder="question.placeholder" :minlength="question.minLength" :maxlength="question.maxLength" :show-word-limit="question.maxLength" clearable></el-input>
        <span class="hint-text"> {{ question.hint }} </span>
      </div>

      <!-- Multi line text (Default: 11) -->
      <div class="registration-question" v-if="question.type == 11">
        <div class="sub-title">{{ question.title }} <span v-show="question.isRequired">*</span></div>
        <el-input type="textarea" v-model="question.answer" :required="question.isRequired" :placeholder="question.placeholder" :minlength="question.minCharAllowed" :maxlength="question.maxCharAllowed" :rows="question.rows" :show-word-limit="question.showLimit" clearable></el-input>
        <span class="hint-text"> {{ question.hint }} </span>
      </div>

      <!-- Email (Default: 12, Unique Email: 1) -->
      <div class="registration-question" v-if="question.type == 12 || question.type == 1">
        <div class="sub-title">{{ question.title }} <span v-show="question.isRequired">*</span></div>
        <el-input suffix-icon="el-icon-edit" v-model="question.answer" :required="question.isRequired" :placeholder="question.placeholder" minlength="5" maxlength="250" clearable></el-input>
        <span class="hint-text"> {{ question.hint }} </span>
      </div>

      <!-- Phone (Default: 13, Unique Mobile: 2, Mobile Phone: 26, Work Phone: 27) -->
      <div class="registration-question" v-if="question.type == 13 || question.type == 2 || question.type == 26 || question.type == 27">
        <div class="sub-title">{{ question.title }} <span v-show="question.isRequired">*</span></div>
        <VuePhoneNumberInput :required="question.isRequired" v-model="phoneNumber" @update="updatePhoneNumber" :placeholder="question.placeholder" clearable />

        <span class="hint-text"> {{ question.hint }} </span>
      </div>

      <!-- Number (Default: 14) -->
      <div class="registration-question" v-if="question.type == 14">
        <div class="sub-title">{{ question.title }} <span v-show="question.isRequired">*</span></div>
        <el-input-number v-model="question.answer" :required="question.isRequired" :min="question.minValue" :max="question.maxvalue" :step="question.step" step-strictly></el-input-number>
        <span class="hint-text"> {{ question.hint }} </span>
      </div>

      <!-- Multiple choice question (Default: 100) -->
      <div class="registration-question" v-if="question.type == 100">
        <div class="sub-title">{{ question.title }} <span v-show="question.isRequired">*</span></div>
        <div class="choice-questions">
          <el-checkbox :checked="question.answers.some(x => x == option.id)" v-for="(option, index) in question.options" :key="option.id + index" :label="option.id" @change="changeAnswers(option.id)">
            {{ option.title }}
          </el-checkbox>
        </div>
        <span class="hint-text"> {{ question.hint }} </span>
      </div>

      <!-- Single choice question (Default: 15) -->
      <div class="registration-question" v-if="question.type == 15">
        <div class="sub-title">{{ question.title }} <span v-show="question.isRequired">*</span></div>
        <div class="choice-questions">
          <!-- <el-radio
          v-model="question.answer"
          :label="index"
          v-for="(options, index) in question.options"
          :key="index">
          {{ options.label }}
        </el-radio> -->
          <!-- <el-radio
          v-model="question.answer"
          :label="options.id"
          v-for="(options, index) in question.options"
          :key="index">
          {{ options.title }}
        </el-radio> -->
          <el-radio v-model="question.answer" :label="options.id" v-for="(options, index) in question.options" :key="index"> {{ options.title }} </el-radio>
        </div>
        <span class="hint-text"> {{ question.hint }} </span>
      </div>

      <!-- Select dropdown (Default: 16) -->
      <div class="registration-question" v-if="question.type == 16 && !question.allowMultipleSelections">
        <div class="sub-title">{{ question.title }} <span v-show="question.isRequired">*</span></div>
        <el-select v-model="question.answer" :multiple="question.allowMultipleSelections" :filterable="question.addSearchbox" @clear="question.answer = null" clearable :placeholder="question.placeholder">
          <el-option v-for="(options, index) in question.options" :key="index" :label="options.title" :value="options.id"> </el-option>
        </el-select>
        <span class="hint-text"> {{ question.hint }} </span>
      </div>
      <!-- Select dropdown (Default: 16)  allowMultipleSelections-->
      <div class="registration-question" v-if="question.type == 16 && question.allowMultipleSelections">
        <div class="sub-title">{{ question.title }} <span v-show="question.isRequired">*</span></div>
        <el-select v-model="question.answers" :multiple="question.allowMultipleSelections" :filterable="question.addSearchbox" :placeholder="question.placeholder">
          <el-option v-for="(options, index) in question.options" :key="index" :label="options.title" :value="options.id"> </el-option>
        </el-select>
        <span class="hint-text"> {{ question.hint }} </span>
      </div>

      <!-- Country select (Default: 8) -->
      <div class="registration-question" v-if="question.type == 8">
        <div class="sub-title">{{ question.title }} <span v-show="question.isRequired">*</span></div>
        <el-select v-model="question.answer" filterable :placeholder="question.placeholder" :required="question.isRequired">
          <el-option required v-for="item in countryList" :key="item.code" :label="item.name" :value="item.name" clearable>
            <div class="custom-option">
              <!-- <img :src="require('../assets/' + item.flag_1x1)" /> -->
              <span> {{ item.name }}</span>
            </div>
          </el-option>
        </el-select>
        <span class="hint-text"> {{ question.hint }} </span>
      </div>

      <!-- Date picker (Default: 101) -->
      <div class="registration-question" v-if="question.type == 101">
        <div class="sub-title">{{ question.title }} <span v-show="question.isRequired">*</span></div>
        <el-date-picker
          v-model="question.answer"
          :required="question.isRequired"
          :placeholder="question.placeholder"
          :format="
            getEnumsDisplay('DateFormat', question.dateFormat)
              .replaceAll('A', 'M')
              .replaceAll('g', 'd')
              .replaceAll('Y', 'y')
          "
          clearable
        ></el-date-picker>
        <span class="hint-text"> {{ question.hint }} </span>
      </div>

      <!-- Time picker (Default: 102) -->
      <div class="registration-question" v-if="question.type == 102">
        <div class="sub-title">{{ question.title }} <span v-show="question.isRequired">*</span></div>
        <el-time-picker v-model="question.answer" :required="question.isRequired" :placeholder="question.placeholder" :format="question.format" clearable></el-time-picker>
        <span class="hint-text"> {{ question.hint }} </span>
      </div>

      <!-- Star rating (Default: 200) -->
      <div class="registration-question" v-if="question.type == 200">
        <div class="sub-title">{{ question.title }} <span v-show="question.isRequired">*</span></div>
        <div class="rate-container">
          <el-rate v-model="question.answer"></el-rate>
        </div>
        <span class="hint-text"> {{ question.hint }} </span>
      </div>

      <!-- Emotion rating (Default: 201) -->
      <div class="registration-question" v-if="question.type == 201">
        <div class="sub-title">{{ question.title }} <span v-show="question.isRequired">*</span></div>
        <div class="rate-container">
          <el-rate v-model="question.answer" :icon-classes="['far fa-frown', 'far fa-meh', 'far fa-smile']" void-icon-class="far fa-meh" :colors="['#99A9BF', '#F7BA2A', '#FF9900']"></el-rate>
        </div>
        <span class="hint-text"> {{ question.hint }} </span>
      </div>

      <!-- Slider rating (Default: 202) -->
      <div class="registration-question" v-if="question.type == 202">
        <div class="sub-title">{{ question.title }} <span v-show="question.isRequired">*</span></div>
        <div class="rate-container">
          <el-slider v-model="question.answer" :min="question.minValue" :max="question.maxvalue" :step="question.step"> </el-slider>
        </div>
        <span class="hint-text"> {{ question.hint }} </span>
      </div>

      <!-- Info block (Default: 500) -->
      <div class="registration-question" v-if="question.type == 500">
        <div>
          <p :style="'color:' + question.infoBlockColor">{{ question.title }}</p>
        </div>
      </div>

      <!-- File upload (Default: 104, Photo: 32) -->
      <div class="registration-question" v-if="question.type == 104 || question.type == 32">
        <div class="sub-title">{{ question.title }} <span v-show="question.isRequired">*</span></div>
        <el-upload class="upload-registration" :class="question.type == 32 ? 'profile-picture-upload' : ''" action="" ref="upload" :http-request="fileUploadBefore" multiple :show-file-list="false" drag>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text" v-html="$t('recursiveQuestionBuilder.dragClick')"></div>
          <div class="el-upload__tip" slot="tip">
            <b>{{ question.fileTypes }}</b> {{ $t("recursiveQuestionBuilder.dragMsg") }} <b>{{ question.maxFileSizeMb }}mb</b>.
          </div>
        </el-upload>
        <span class="hint-text"> {{ question.hint }} </span>
        <CoolLightBox :items="question.answers" :index="imageIndex" @close="imageIndex = null"> </CoolLightBox>
        <div class="answers-files" v-if="question.type == 32">
          <div class="answers-files-img" v-for="(file, index) in question.answers" @click="imageIndex = index" :key="index + '-question-file-' + question.id">
            <img :src="file" />
            <i class="fas fa-minus-circle" @click.stop="question.answers.splice(index, 1)"></i>
          </div>
        </div>
        <div class="answers-files-doc" v-else>
          <div class="answers-doc-item" v-for="(file, fileIndex) in files" :key="fileIndex + 'file-index'">
            <span>
              {{ file.filenameReal }}
            </span>
            <i
              class="fas fa-minus-circle"
              @click.stop="
                question.answers.splice(fileIndex, 1);
                files.splice(fileIndex, 1);
              "
            ></i>
          </div>
        </div>
      </div>
    </template>

    <!-- Rich text editor (Default: 103) -->
    <!-- Rich text editor (Şimdilik iptal) -->

    <!-- <template v-if="question.answer != null && availableQuestions">
      <SurveyQuestionBuilder :baseValidationKey="baseValidationKey"
        v-for="(question2, index) in availableQuestions.filter((x) => x.parentAnswerId == question.answer)"
        :key="availableQuestions.length + index + Math.random(100000).toString()" :question="question2"
        :allQuestions="allQuestions" :availableQuestions="availableQuestions" />
    </template>
    <template v-if="question.answers.length > 0 && availableQuestions">
      <SurveyQuestionBuilder :baseValidationKey="baseValidationKey"
        v-for="(question2, index) in this.availableQuestions.filter(({ parentAnswerId }) => this.question.answers.includes(parentAnswerId))"
        :key="availableQuestions.length + index + Math.random(100000).toString()" :question="question2"
        :allQuestions="allQuestions" :availableQuestions="availableQuestions" />
    </template> -->
  </div>
</template>

<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import axios from "axios";
import countryList from "./countryList.json";
export default {
  components: { VuePhoneNumberInput },
  name: "SurveyQuestionBuilder",
  props: ["question", "baseId", "baseValidationKey", "allQuestions", "availableQuestions", "currentIndex", "registrationFormId"],
  data() {
    return {
      files: [],
      phoneNumber: null,
      countryList,
      phoneNumberObject: null,
      imageIndex: null
    };
  },
  created() {
    this.phoneNumber = this.question.answer;
    if (this.question.answers == null) {
      this.question.answers = [];
    }
    if (this.question.type == 202 && this.question.answer != null) {
      this.question.initialValue = parseInt(this.question.answer);
    }
    if (this.question.answer != null && (this.question.type == 15 || this.question.type == 16)) {
      var subQuestions = this.allQuestions.filter(x => x.parentAnswerId == this.question.answer);
      if (subQuestions.length > 0) {
        for (let index = 0; index < subQuestions.length; index++) {
          const element = subQuestions[index];
          if (!this.availableQuestions.some(x => x.id == element.id)) {
            this.availableQuestions.push(element);
          }
        }
      }
    }
    if (this.question.answers.length > 0) {
      this.loadAnswersQuestions();
    }
  },
  methods: {
    async fileUploadBefore(file) {
      console.log("file", file.file);
      let formData = new FormData();
      formData.append("file", file.file);
      var response = await axios.post("registration/uploadfile?uploadType=registrationForm&registrationFormId=" + this.registrationFormId + "&questionId=" + this.question.id, formData, {
        "Content-Type": "multipart/form-data"
      });
      if (response.hasError) {
        this.$message.error(response.data.message);
      } else {
        this.$message.success(response.data.message);
        if (this.question.type == 104) {
          this.files.push(response.data.data.item);
        }
        this.question.answers.push(response.data.data.item.url);
      }
    },
    availableQuestions2() {
      return;
    },
    updateRate(number) {
      this.question.answer = number.toString();
    },
    updateSlider(number) {
      this.question.initialValue = number;
      this.question.answer = number.toString();
    },
    updatePhoneNumber(payload) {
      this.$nextTick(() => {
        this.phoneNumberObject = payload;
      });
      this.$nextTick(() => {
        this.question.answer = this.phoneNumberObject.formattedNumber;
      });
    },
    changeAnswers(id) {
      if (this.question.answers.some(x => x == id)) {
        var cIndex = this.question.answers.findIndex(x => x == id);
        if (cIndex != -1) {
          this.question.answers.splice(cIndex, 1);
        }
      } else {
        this.question.answers.push(id);
      }
    },
    loadAnswersQuestions() {
      this.question.answers.map(newValAnswer => {
        var subQuestions = this.allQuestions.filter(x => x.parentAnswerId == newValAnswer);
        if (subQuestions.length > 0) {
          for (let index = 0; index < subQuestions.length; index++) {
            const element = subQuestions[index];
            if (!this.availableQuestions.some(x => x.id == element.id)) {
              this.availableQuestions.push(element);
            }
          }
        }
      });
    }
  },
  computed: {
    getEnums() {
      return this.$store.getters.getEnums;
    },
    // calculateQuestionDisplay() {
    //   var currentAvailableQuestion = this.availableQuestions.find(x => x.type == 100 ? x.answers.length == 0 : x.answer == null);
    //   if(currentAvailableQuestion == null)
    //   {
    //     //Daha fazla soru yok
    //     return false;
    //   }

    //   if(this.question.type == 100)
    //   {
    //     if(this.question.answers != null && this.question.answers.length > 0)
    //     {
    //       return false;
    //     }
    //   }
    //   else
    //   {
    //     if(currentAvailableQuestion.id != this.question.id)
    //     {
    //       return false;
    //     }
    //   }
    //   return true;
    // },

    answer_str() {
      return JSON.parse(JSON.stringify(this.question.answers));
    }
  },

  watch: {
    answer_str: function(newValue_str, oldValue_str) {
      let newValue = newValue_str;
      let oldValue = oldValue_str;
      if (oldValue != null) {
        oldValue.map(oldValAnswer => {
          var subQuestions = this.allQuestions.filter(x => x.parentAnswerId == oldValAnswer);
          if (subQuestions.length > 0) {
            for (let index = 0; index < subQuestions.length; index++) {
              const element = subQuestions[index];
              var indexx = this.availableQuestions.findIndex(x => x.id == element.id);
              if (indexx != -1) {
                this.availableQuestions.splice(indexx, 1);
              }
            }
          }
        });
      }
      if (newValue != null) {
        newValue.map(newValAnswer => {
          var subQuestions = this.allQuestions.filter(x => x.parentAnswerId == newValAnswer);
          if (subQuestions.length > 0) {
            console.log(subQuestions.length);
            for (let index = 0; index < subQuestions.length; index++) {
              const element = subQuestions[index];

              if (!this.availableQuestions.some(x => x.id == element.id)) {
                element.answer = null;
                element.answers = null;
                this.availableQuestions.splice(this.currentIndex + 1, 0, element);
              }
            }
          }
        });
      }

      // var temp = [];
      // for (let index = 0; index < this.availableQuestions.length; index++) {
      //   const element = array[index];
      //   if(!temp.some(x => x.id == element.id))
      //   {
      //     temp.push(element);
      //   }
      // }
      // this.availableQuestions = temp;
    },
    "question.answer": function(newVal, oldVal) {
      if (oldVal != null && !this.question.allowMultipleSelections && (this.question.type == 15 || this.question.type == 16)) {
        var subQuestions = this.allQuestions.filter(x => x.parentAnswerId == oldVal);
        if (subQuestions.length > 0) {
          for (let index = 0; index < subQuestions.length; index++) {
            const element = subQuestions[index];
            var indexx = this.availableQuestions.findIndex(x => x.id == element.id);
            if (indexx != -1) {
              this.availableQuestions.splice(indexx, 1);
            }
          }
        }
      }

      if (newVal != null && !this.question.allowMultipleSelections && (this.question.type == 15 || this.question.type == 16)) {
        var subQuestions = this.allQuestions.filter(x => x.parentAnswerId == newVal);
        if (subQuestions.length > 0) {
          for (let index = 0; index < subQuestions.length; index++) {
            const element = subQuestions[index];
            if (!this.availableQuestions.some(x => x.id == element.id)) {
              element.answer = null;
              this.availableQuestions.splice(this.currentIndex + 1, 0, element);
            }
          }
        }
      }

      // var temp = [];
      // for (let index = 0; index < this.availableQuestions.length; index++) {
      //   const element = array[index];
      //   if(!temp.some(x => x.id == element.id))
      //   {
      //     temp.push(element);
      //   }
      // }
      // this.availableQuestions = temp;
    }
  }
};
</script>

<style lang="less">
.registration-question {
  width: 100%;
  transition: 1s;
  margin-top: 18px;
  .answers-files-doc {
    display: flex;
    flex-direction: column;
    gap: 10px;
    .answers-doc-item {
      display: flex;
      gap: 10px;
      span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: bold;
        color: #292f3b;
      }
      i {
        font-size: 16px;
        background: white;
        border-radius: 50%;
        cursor: pointer;
        color: red;
      }
    }
  }
  .answers-files {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 10px;
    .answers-files-img {
      border-radius: 12px;
      display: block;
      cursor: pointer;
      position: relative;
      i {
        font-size: 16px;
        background: white;
        border-radius: 50%;
        right: -4px;
        top: -4px;
        cursor: pointer;
        position: absolute;
        color: red;
        display: block;
      }
      img {
        border-radius: 12px;
        aspect-ratio: 1;
        object-position: center;
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }
  }
  .el-upload {
    width: 100%;
    .el-upload-dragger {
      width: 100%;
    }
  }
  .sub-title {
    color: #292f3b;
    font-weight: 400;
    margin-bottom: 8px;
    font-size: 14px;
  }

  span {
    color: #505763;
    white-space: normal;
    font-size: 13px;
    font-weight: 400;
  }

  .choice-questions {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-date-editor {
    width: 100% !important;
  }

  .rate-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 150px;

    .el-slider {
      width: 100%;
    }
  }
}

.question-builder-actions {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  span {
    color: #292f3b;
    font-size: 14px;

    b {
      color: #292f3b;
      font-weight: 500;
    }
  }

  .question-builder-button {
    color: white;

    span {
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/event/socialHub/SurveyQuestionBuilder.vue